import { useState, useEffect } from "react";
import { getDocFormsComlpleted, getDocFormsToAssign } from "../../../Services/docForm.service";
import  useDocFormsStore  from "../store/docFormsStore";
export const useAssignedForms = () => {
    const setLoading = useDocFormsStore((state) => state.setLoading);
    const assignedForms = useDocFormsStore((state) => state.assignedForms);
    const setAssignedForms = useDocFormsStore((state) => state.setAssignedForms);
    const completedForms = useDocFormsStore((state) => state.completedForms);
    const setCompletedForms = useDocFormsStore((state) => state.setCompletedForms);
    useEffect(() => {
        getAssignedForms();
    }, []);

    const getAssignedForms = async () => {
        try {
            const response = await getDocFormsToAssign();
            setAssignedForms(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const getAssignedFormsFilteredByCompleted = async () => {
        const response = await getDocFormsComlpleted();
        setCompletedForms(response.data);
    }

    return { assignedForms, getAssignedForms, getAssignedFormsFilteredByCompleted, completedForms };
};